module.exports = __webpack_public_path__ + "8092bdf7f9bc7be017c048063293624b.png";